<template>
  <div class="flex flex-column flex-grow-1" :class="`${AppConfig.theme}-theme`">
    <label class="label-top">{{ props.label }}</label>
    <div class="p-float-label">
      <InputText v-model="v$.value.$model" v-bind="$attrs" style="width: 100%"></InputText>
      <label class="label-border">{{ props.label }}</label>
    </div>
    <div class="flex">
      <small v-if="v$.value.$error" class="p-error">Email is invalid</small>
      <small v-if="!v$.value.$error && props.required" id="nin_number-help" class="help-text"
        >*{{ t('general.required') }}</small
      >
    </div>
  </div>
</template>
<script setup>
import { ref, computed } from 'vue'
import { useVuelidate } from '@vuelidate/core'
import { required, email } from '@vuelidate/validators'
import { useI18nUtils } from '@/composables/utils/useI18nUtils.js'
import AppConfig from '~/config/appConfig.js'
const props = defineProps({
  modelValue: String,
  label: {
    type: String,
    required: true
  },
  required: Boolean
})

const { t } = useI18nUtils()
const value = ref(props.modelValue)

const rules = computed(() => {
  const v = {}
  if (props.required) {
    v.value = { required, email }
  } else {
    v.value = { email }
  }
  return v
})

const v$ = useVuelidate(rules, { value })
</script>
<style scoped>
label {
  font-weight: 550;
  color: #013315;
}

input {
  height: 40px;
  box-shadow: 1px 2px 4px #00000029;
  border: 0.5px solid #E5E5E5;
  border-radius: 8px;
}
.label-top {
  margin-bottom: 8px;
  display: none;
}

@media screen and (min-width: 768px) {
  .label-top {
    display: block;
  }

  .label-border {
    display: none;
  }
}
.sbg-theme label {
  color: rgba(0, 0, 0, 0.6);
  font-weight: normal;
  width: auto;
}

.sbg-theme .label-top {
  display: none;
}

.sbg-theme .label-border {
  display: block;
}

.sbg-theme input:focus ~ .label-border {
  color: #00afa5;
}

.sbg-theme input {
  height: auto;
  line-height: normal;
  box-shadow: none;
  border: 1px solid rgba(0, 0, 0, 0.38);
}

.sbg-theme input:focus {
  box-shadow: inset 0 0 0 1px #00afa5, inset 0 0 0 1px #00afa5, inset 0 0 0 1px #00afa5, inset 0 0 0 1px #00afa5;
}
</style>
